export const SEARCH_CONTENT_SUGGESTIONS_GQL = `
  query SearchContentSuggestions(
    $searchTerm: String!
    $articleLimit: Int!
    $competitionLimit: Int!
    $publishedDateGte: DateTime!
    $competitionEndDateGte: DateTime!
  ) {
    articleCollection(
      limit: $articleLimit
      order: publishedDate_DESC
      where: {
        publishedDate_gte: $publishedDateGte
        OR: [{ heading_contains: $searchTerm }, { intro_contains: $searchTerm }]
      }
    ) {
      items {
        sys {
          id
          publishedAt
        }
        heading
        intro
        publishedDate
        urlSlug
        parentPage {
          sys {
            id
          }
          categoryPage {
            sys {
              id
            }
            urlSlug
          }
        }
        heroImage {
          ...AssetFields
        }
        heroVideo {
          sys {
            id
          }
          landscapeCoverImage {
            ...AssetFields
          }
        }
      }
    }
    competitionCollection(
      limit: $competitionLimit
      order: endDate_ASC
      where: {
        endDate_gte: $competitionEndDateGte
        heading_contains: $searchTerm
        hideFromCardGrid_not: true
      }
    ) {
      items {
        sys {
          id
          publishedAt
        }
        heading
        endDate
        urlSlug
        hideFromCardGrid
        parentPage {
          sys {
            id
          }
          categoryPage {
            sys {
              id
            }
            urlSlug
          }
        }
        heroImage {
          ...AssetFields
        }
      }
    }
  }

  fragment AssetFields on Asset {
    sys {
      id
    }
    title
    description
    url
    fileName
    contentType
    size
    width
    height
  }
`;
